<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_WORK_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <div class="comm_label"> 
            <sui-input-label
              ref="msgResoLabel"
              :style="inputSize"
              :label="frame0.selectedPreMsgTaskId"
              :vertical="false"
            />
            </div>
            <sui-text-field
              ref="msgTaskId"
              v-model="frame0.taskId"
              :readonly="false"
              :maxlength="frame0.userMaxlength"
              @keyup.enter="onClickDupCheck"
              @keyup="onKeyUpInput"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              class="comm_btn_duplicate"
              :disabled="taskIdCheckFlag"
              @click="onClickDupCheck"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_UP_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-input-label
              ref="msgParentTaskId"
              :label="frame0.parentTaskId"
              :vertical="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_WORK_NM')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-10">
            <cmp-mlng-editor
              ref="mlngEditor"
              :pageId="pageId"
              :multiLanguageId="multiLanguageId"
              :vertical="false"
              :editable="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-10">
            <sui-radio
              v-model="frame0.taskUseYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.taskUseYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_ARRAY_ORDER')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              ref="sortOrder"
              v-model="frame0.arylOrd"
              :disabled="false"
              :readonly="false"
              maxlength="4"
              mask="number"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_WORK_CONTENTS')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="frame0.taskContents"
              rows="8"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMY_00021'"
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';
/*  eslint max-len: ["error", { "code": 200 }] */
export default {
  name: 'PGE_CMY_00021_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMY_00021',
    },
    taskId: {
      type: String,
      default: null,
    },
    taskIdLvlName: {
      type: String,
      default: null,
    },
    taskIdLvl: {
      type: String,
      default: null,
    },
    parentTaskId: {
      type: String,
      default: null,
    },
    pTaskLvl: {
      type: String,
      default: null,
    },
    taskIdInputSize: {
      type: String,
      default: null,
    },
    // multiLanguageId: {
    //   type: String,
    //   default: null,
    // },
  },
  data() {
    return {
      // Codes
      frame0: {
        taskUseYn: '',
        // taskId: '',
        // taskUpId: '',
        arylOrd: '',
        taskContents: '',
        taskMlngId: '',
        selectedPreMsgTaskId: '',
        parentTaskId: '',
        taskId: '',
        userMaxlength: '',
        pTaskLvl: '',
      },
      multiLanguageId: '',
      taskIdCheckFlag: false,
      orgTaskId: '',
      inputSize: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    console.log('taskId : ', this.taskId);
    console.log('taskIdLvlName : ', this.taskIdLvlName);
    console.log('parentTaskId : ', this.parentTaskId);
    this.frame0.selectedPreMsgTaskId = this.taskIdLvlName;
    this.frame0.parentTaskId = this.parentTaskId;
    this.frame0.taskIdLvl = this.taskIdLvl;
    this.frame0.pTaskLvl = this.pTaskLvl;

    if (this.taskIdLvl === '' || this.taskIdLvl === null) {
      this.frame0.userMaxlength = '8';
      this.inputSize = this.taskIdInputSize;
    } else if (this.taskIdLvl === '1') {
      this.frame0.userMaxlength = '6';
    } else if (this.taskIdLvl === '2') {
      this.frame0.userMaxlength = '3';
    }
    // this.frame0.taskId = this.taskIdLvlName;
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onKeyUpInput() {
      if (this.orgTaskId !== this.frame0.taskId) {
        this.taskIdCheckFlag = false;
      }
    },
    onClickDupCheck() {
      if (this.frame0.taskId) {
        if (this.taskIdLvl === '1' && utils.isOnlyDigit(this.frame0.taskId) === false) {
          utils.messageBox('warning', this.$t('MSG_ALT_ONLY_NUMBER'), null, () => {
            this.frame0.taskId = '';
            this.$refs.msgTaskId.setFocus();
            this.taskIdCheckFlag = false;
          });
          return;
        }

        if (this.taskIdLvl === '2' && utils.isOnlyDigit(this.frame0.taskId) === false) {
          utils.messageBox('warning', this.$t('MSG_ALT_ONLY_NUMBER'), null, () => {
            this.frame0.taskId = '';
            this.$refs.msgTaskId.setFocus();
            this.taskIdCheckFlag = false;
          });
          return;
        }

        if (this.taskIdLvl === '' && utils.isUpperEngNum_(this.frame0.taskId) === false) {
          utils.messageBox('warning', this.$t('MSG_ALT_ONLY_UPPER_ENGLISH_NUMBER'), null, () => {
            this.frame0.taskId = '';
            this.$refs.msgTaskId.setFocus();
            this.taskIdCheckFlag = false;
          });
          return;
        }
      }

      if (utils.isEmpty(utils.trim(this.frame0.taskId)) === true) {
        return;
      }

      this.orgTaskId = this.frame0.taskId;
      const queryParams = {
        taskId: `${this.frame0.selectedPreMsgTaskId + this.frame0.taskId}`,
      };
      http.request(this.pageId, 'DTS_CMY_00051', {
        query: queryParams,
      }).then(res => {
        if (!res.data) {
          utils.messageBox('information', this.$t('MSG_ALT_USABLE_TASK_ID'), null, () => {
            this.taskIdCheckFlag = true;
          });
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_TASK_ID'), null, () => {
            this.frame0.taskId = '';
            this.$refs.msgTaskId.setFocus();
            this.taskIdCheckFlag = false;
          });
        }
      }).catch(() => {
        // utils.alert(this.$t('MSG_ALT_ERR_CONTACT_ADMIN'), this.$t('MSG_BTN_CFRM'));
        utils.messageBox('warning', this.$t('MSG_ALT_ERR_CONTACT_ADMIN'));
      });
    },
    onClose() {
      this.$emit('close');
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue);
    },
    onSave() {
      const multiLanguageList = this.$refs.mlngEditor.getMlngEditingInfoFillEmptyWithGlobal();

      if (this.taskIdLvl === '') {
        // this.taskIdLvl = '1';
        this.frame0.taskIdLvl = '1';
      } else {
        // this.taskIdLvl = this.pTaskLvl;
        this.frame0.taskIdLvl = this.pTaskLvl;
      }

      const dataParams = {
        taskId: `${this.frame0.selectedPreMsgTaskId + this.frame0.taskId.replace(/\s/gi, '')}`,
        parentTaskId: this.frame0.parentTaskId,
        taskUseYn: this.frame0.taskUseYn,
        arylOrd: this.frame0.arylOrd,
        taskContents: this.frame0.taskContents,
        taskLvl: utils.toCharNum(this.frame0.taskIdLvl),
        taskMlngId: `${this.frame0.selectedPreMsgTaskId + this.frame0.taskId}`,
        multiLanguageId: `${this.frame0.selectedPreMsgTaskId + this.frame0.taskId}`,
        multiLanguageList,
      };

      if (utils.isEmpty(utils.trim(dataParams.taskId)) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_ID')), null);
        return;
      }

      if (utils.trim(dataParams.taskId.length) < 12) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_TASK_ID_LEN'), null), null);
        return;
      }

      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.localTxtFld.value)) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_NM')), null);
        return;
      }

      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.globalTxtFld.value))) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_ALT_GLOBAL_ENM')), null);
        return;
      }

      if (utils.isEmpty(utils.trim(dataParams.taskUseYn)) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN')), null);
        return;
      }

      if (utils.isEmpty(dataParams.arylOrd) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_ARRAY_ORDER')), null);
        return;
      }

      if (utils.isEmpty(dataParams.taskContents) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_CONTENTS')), null);
        return;
      }

      if (this.taskIdCheckFlag) {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
          console.log(this.pageId);
          http.request(this.pageId, 'DTS_CMY_00052', {
            data: dataParams,
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null);
            this.$emit('close');
            // this.$emit('onSearchClick');
          }).catch(error => {
            console.log(error);
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_SELT_DPCT_CHK'));
      }
    },
  },
};
</script>
<style scoped>
</style>
